import BaseAxios from 'axios';
import { store } from 'store';
import { checkIfAdmin } from 'store/selectors/loginState';
import { getCookie, ApiPrefix } from 'util/icwUtility';

class Request {
  axios;

  constructor() {
    // Timeout is 60 * 60000 = 60x60s = 60m = 1hour
    this.axios = BaseAxios.create({ timeout: 3600000 });
  }

  async call({ headers: extraHeader, ...config }) {
    try {
      const serverBaseUrl = config.apiPrefix || ApiPrefix;
      const state = store.getState();
      const isAdmin = checkIfAdmin(state);
      const token = getCookie(isAdmin ? 'adminToken' : 'token');
      const headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: token || config.token ? `${token || config.token}` : undefined,
        ...extraHeader,
      };
      const res = await this.axios.request({
        baseURL: serverBaseUrl,
        headers: {
          ...headers,
        },
        ...config,
      });
      return res;
    } catch (error) {
      // Error handler
      return { error: true, errorObj: error?.response?.data };
    }
  }
}

export default new Request();
